"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));
var _excluded = ["id", "name", "value", "label", "placeholder", "helper", "floatLabel", "required", "disabled", "editable", "onChange", "onError", "incrementAmount", "min", "max", "color", "outline", "className", "noValidate", "labelAria"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The InputIncrement component allows an user to adjust a value within a specific range.
 */
var InputIncrement = function InputIncrement(props) {
  var controlledId = props.id,
    name = props.name,
    controlledValue = props.value,
    initialLabel = props.label,
    placeholder = props.placeholder,
    helper = props.helper,
    floatLabel = props.floatLabel,
    required = props.required,
    disabled = props.disabled,
    editable = props.editable,
    onChange = props.onChange,
    onError = props.onError,
    incrementAmount = props.incrementAmount,
    min = props.min,
    max = props.max,
    color = props.color,
    outline = props.outline,
    className = props.className,
    noValidate = props.noValidate,
    labelAria = props.labelAria,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var inputRef = _react.default.useRef(null);
  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  var _React$useState = _react.default.useState(+controlledValue || +min || 0),
    currentAmount = _React$useState[0],
    setCurrentAmount = _React$useState[1];
  var _React$useState2 = _react.default.useState(false),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _useFormElementValida = (0, _useFormElementValidation.default)(currentAmount, noValidate ? {} : {
      required: required,
      number: true,
      min: min,
      max: max
    }),
    errors = _useFormElementValida[0],
    methods = _useFormElementValida[1];
  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
      id: id,
      value: currentAmount
    })),
    label = _useLabel.label;
  _react.default.useEffect(function () {
    setCurrentAmount(+controlledValue || +min || 0);
  }, [controlledValue, min]);

  // React.useEffect(() => {
  //     const formattedValue = parseInt(newValue, 10);
  //     setCurrentAmount(formattedValue);
  // }, [newValue]);

  _react.default.useEffect(function () {
    setError(errors.length > 0);
  }, [errors]);
  var handleDecrement = function handleDecrement() {
    if (currentAmount <= min) {
      return min;
    }
    return currentAmount - incrementAmount;
  };
  var handleIncrement = function handleIncrement() {
    if (currentAmount >= max) {
      return max;
    }
    return currentAmount + incrementAmount;
  };
  var handleInputBlur = function handleInputBlur() {
    var formattedValue;
    if (currentAmount > max) {
      formattedValue = max;
    } else if (currentAmount < min) {
      formattedValue = min;
    } else {
      formattedValue = currentAmount;
    }
    var value = parseInt(formattedValue, 10) || 0;
    methods.onChange(value);
    if (typeof onChange === 'function') {
      onChange(value, inputRef.current.name);
    }
  };
  var handleInputChange = function handleInputChange() {
    var value = parseInt(inputRef.current.value, 10) || 0;
    methods.onChange(value);
    if (typeof onChange === 'function') {
      onChange(value, inputRef.current.name);
    }
  };
  var handleAddSub = function handleAddSub(idButton) {
    var newAmount;
    if (idButton === 'inc') {
      newAmount = handleIncrement();
    } else if (idButton === 'dec') {
      newAmount = handleDecrement();
    }
    methods.onChange(newAmount);
    var formattedValue = parseInt(newAmount, 10);
    setCurrentAmount(formattedValue);
    if (typeof onChange === 'function') {
      onChange(newAmount, inputRef.current.name);
    }
  };
  var containerClasses = (0, _clsx.default)('uk-form-item', 'uk-input', 'uk-input--increment', (helper.length > 0 || error) && 'has-helper', error && 'has-error', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: "-",
    id: "dec",
    disabled: disabled || currentAmount <= min,
    onClick: function onClick() {
      return handleAddSub('dec');
    },
    color: color,
    outline: outline,
    type: "button",
    "aria-disabled": disabled || currentAmount <= min,
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: inputRef,
    type: "number",
    role: "spinbutton",
    id: id,
    name: name || id,
    value: currentAmount,
    placeholder: placeholder && !floatLabel ? placeholder : null,
    autoComplete: "off",
    disabled: disabled,
    readOnly: !editable,
    required: required,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    min: min,
    max: max,
    step: incrementAmount,
    className: "uk-inputtable",
    "aria-valuenow": currentAmount,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-describedby": (name || id) + "-helper-text " + (name || id) + "-required-message",
    "aria-errormessage": (name || id) + "-helper-text",
    "aria-invalid": error
  }, attributes)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: "+",
    id: "inc",
    disabled: disabled || currentAmount >= max,
    onClick: function onClick() {
      return handleAddSub('inc');
    },
    color: color,
    outline: outline,
    type: "button",
    "aria-disabled": disabled || currentAmount >= max,
    "aria-hidden": "true"
  })), helper.length > 0 && /*#__PURE__*/_react.default.createElement("small", {
    className: "uk-form-item__helper",
    id: (name || id) + "-helper-text"
  }, helper));
};
InputIncrement.propTypes = {
  /**
   * ID of the Input (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the Input (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default value of the Input
   */
  value: _propTypes.default.number,
  /**
   * Label of the Input
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Input placeholder
   */
  placeholder: _propTypes.default.string,
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,
  /**
   * Amount to incrementally add/subtract
   */
  incrementAmount: _propTypes.default.number,
  /**
   * Minimum value of the Input
   */
  min: _propTypes.default.number,
  /**
   * Maximum value of the Input
   */
  max: _propTypes.default.number,
  /**
   * Background-color of the Buttons (or border-color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'black', 'white', 'custom']),
  /**
   * Invert styling colors of the Buttons
   */
  outline: _propTypes.default.bool,
  /**
   * Set the input as editable
   */
  editable: _propTypes.default.bool,
  /**
   * Set the Input as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the Input as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Disable validation
   */
  noValidate: _propTypes.default.bool,
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string
};
InputIncrement.defaultProps = {
  placeholder: '',
  helper: '',
  floatLabel: false,
  incrementAmount: 1,
  editable: false,
  disabled: false,
  required: false,
  noValidate: false
};
var _default = exports.default = InputIncrement;